import React, { useState, useEffect } from 'react';
import { InputGroup, Label, Input } from 'reactstrap';
import { connect } from 'react-redux';
import { registerUser, resetForm } from '../actions/formActions';
import classnames from 'classnames';
import { Link, useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Spinner from './Spinner';

const SignUp = ({ errors: propErrors, auth, cart, registerUser, resetForm }: any) => {
  const history = useHistory();

  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [errors, setErrors] = useState<any>({});
  const [phoneNumber, setPhoneNumber] = useState('');
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  useEffect(() => {
    return () => {
      resetForm();
    };
  }, []);

  useEffect(() => {
    setErrors(propErrors);
  }, [propErrors]);

  useEffect(() => {
    if (auth.showRegistrationSuccess) {
      setShowSuccessMessage(true);
      const timer = setTimeout(() => {
        history.push('/login');
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [auth.showRegistrationSuccess]);

  const onChange = (e) => {
    const { name, value } = e.target;
    if (name === 'firstName') setFirstName(value);
    else if (name === 'lastName') setLastName(value);
    else if (name === 'email') setEmail(value);
    else if (name === 'password') setPassword(value);
    else if (name === 'password2') setPassword2(value);
    else if (name === 'phoneNumber') setPhoneNumber(value);
  };

  const onSubmit = (e) => {
    e.preventDefault();

    let newUser = {
      registeredUser: true,
      firstName,
      lastName,
      email,
      password,
      password2,
      cart: cart.cart,
      phoneNumber,
    };

    registerUser(newUser, history);
  };

  return (
    <div>
      <div>
        <Helmet>
          <title>Sign Up - Frozberries Victoria</title>
          <meta name="description" content="Sign Up - Frozberries Victoria" />
        </Helmet>
      </div>

      <div className="container my-5 py-5" style={{ minHeight: '50vh' }}>
        <div className="row">
          <div className="col-md-8 m-auto">
            <h1 className="display-4 text-center mb-5">Register</h1>
            <form onSubmit={onSubmit}>
              <InputGroup className="my-2">
                <Input
                  placeholder="First Name"
                  onChange={onChange}
                  className={classnames('', { 'is-invalid': errors.firstName })}
                  value={firstName}
                  name="firstName"
                />
                <div className="invalid-feedback">{errors.firstName}</div>
              </InputGroup>
              <InputGroup className="my-2">
                <Input
                  placeholder="Last Name"
                  onChange={onChange}
                  className={classnames('', { 'is-invalid': errors.lastName })}
                  value={lastName}
                  name="lastName"
                />
                <div className="invalid-feedback">{errors.lastName}</div>
              </InputGroup>
              <InputGroup className="my-2">
                <Input
                  placeholder="Email"
                  onChange={onChange}
                  className={classnames('', { 'is-invalid': errors.email })}
                  value={email}
                  name="email"
                />
                <div className="invalid-feedback">{errors.email}</div>
              </InputGroup>

              <InputGroup className="my-2">
                <Input
                  placeholder="Phone number"
                  onChange={onChange}
                  className={classnames('', { 'is-invalid': errors.phoneNumber })}
                  value={phoneNumber}
                  name="phoneNumber"
                />
                <div className="invalid-feedback">{errors.phoneNumber}</div>
              </InputGroup>

              <InputGroup className="my-2">
                <Input
                  autoComplete="on"
                  type="password"
                  placeholder="Password"
                  onChange={onChange}
                  className={classnames('', { 'is-invalid': errors.password })}
                  value={password}
                  name="password"
                />
                <div className="invalid-feedback">{errors.password}</div>
              </InputGroup>

              <InputGroup className="my-2">
                <Input
                  autoComplete="on"
                  type="password"
                  placeholder="Confirm password"
                  onChange={onChange}
                  className={classnames('', { 'is-invalid': errors.password2 })}
                  value={password2}
                  name="password2"
                />
                <div className="invalid-feedback">{errors.password2}</div>
              </InputGroup>
              <small className="float-left pb-2">
                Already a member? <Link to="/login">Sign in</Link>
              </small>

              <InputGroup className="ml-4 ">
                <Input type="checkbox" className="form-check-input" id="invalidCheck" required />
                <Label check className="form-check-label" htmlFor="invalidCheck">
                  Agree to terms and conditions
                </Label>
              </InputGroup>

              {auth.spinner && (
                <div className="text-center">
                  <Spinner />
                </div>
              )}

              {showSuccessMessage && (
                <div>
                  <p className="text-success">
                    Your account has been successfully created. You're being redirected to login
                    page.
                  </p>
                </div>
              )}

              <Input
                disabled={
                  firstName === '' || email === '' || password === '' || password2 === ''
                    ? true
                    : false
                }
                type="submit"
                value={auth.spinner ? 'Please Wait..' : 'Register'}
                style={{ backgroundColor: 'rgb(236,23,79)' }}
                className="text-light btn-block mt-4 p-2 border-0"
              />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  errors: state.errors,
  auth: state.form,
  cart: state.cart,
});

export default connect(mapStateToProps, { registerUser, resetForm })(SignUp);
